import React, { useState, useCallback } from 'react';
import './BioModal.css';

function AdvisoryCard({ member }) {
  const [showBio, setShowBio] = useState(false);
  const open = useCallback(() => setShowBio(true), []);
  const close = useCallback(() => setShowBio(false), []);

  return (
    <>
      <div className="advisory-card reveal" onClick={open}>
        <div className="advisory-photo-wrap">
          <img src={member.photo} alt={member.name} className="advisory-photo" loading="lazy" />
        </div>
        <h4 className="advisory-name">{member.name}</h4>
      </div>
      {showBio && <BioModal member={member} onClose={close} />}
    </>
  );
}

function BioModal({ member, onClose }) {
  return (
    <div className="bio-modal-overlay" onClick={onClose}>
      <div className="bio-modal" onClick={(e) => e.stopPropagation()}>
        <button className="bio-modal-close" onClick={onClose}>&times;</button>
        <div className="bio-modal-header">
          <img src={member.photo} alt={member.name} className="bio-modal-photo" />
          <h3>{member.name}</h3>
        </div>
        <p className="bio-modal-text">{member.bio}</p>
      </div>
    </div>
  );
}

export default AdvisoryCard;
